import { GetStaticProps } from 'next';
import { GetStaticPropsContext } from 'next/types';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ENavTransparency } from '@features/navigation/typescript';
import { IHeaderObject, IContact, IInformation, IVideo } from '@features/voxbox/typescript';
import getVoxboxData from '@features/voxbox/api';
import HeaderSection from '@features/voxbox/sections/Header/HeaderSection';
import VideoSection from '@features/voxbox/sections/Video/VideoSection';
import InformationSection from '@features/voxbox/sections/Information/InformationSection';
import ContactSection from '@features/voxbox/sections/Contact/ContactSection';
import { getLayoutData } from '@features/layout/api';
import { ISeo, TLocale } from '@typescript/index';
import MainSeo from '@components/MainSeo/MainSeo';
import { REVALIDATION_TIME } from '@config/index';
import { getDevProps } from '@components/DevToolbar/helpers/getDevProps';
export type PropsType = {
  header: IHeaderObject;
  contact: IContact;
  information: IInformation;
  video: IVideo;
  seo: ISeo;
  isBuildTime?: boolean;
};
const Voxbox = ({
  seo,
  header,
  contact,
  information,
  video,
  isBuildTime
}: PropsType) => {
  if (isBuildTime) {
    return <div>Build time</div>;
  }
  return <main id="main-content">
      {seo && <MainSeo seo={seo} />}
      <HeaderSection header={header} />
      <VideoSection video={video} />
      <InformationSection information={information} />
      <ContactSection contact={contact} />
    </main>;
};
export const getStaticProps: GetStaticProps = async ({
  locale
}: GetStaticPropsContext) => {
  if (process.env.IS_BUILD) {
    return {
      props: {
        isBuildTime: true
      },
      revalidate: 1
    };
  }
  return {
    props: {
      ...getDevProps('static', REVALIDATION_TIME),
      ...(await getVoxboxData(locale)),
      isBuildTime: false,
      ...(await getLayoutData(locale as TLocale)),
      ...(await serverSideTranslations(locale as string)),
      navParams: {
        navTransparency: ENavTransparency.BOTH_TRANSPARENT
      }
    },
    revalidate: REVALIDATION_TIME
  };
};
export default Voxbox;